import React, { useEffect, useState } from 'react';
import './CompanyRegApprovalRejectionScreen_Old.css';
import './RegApprovalRejectionScreen.css'
import RegisterHeader from "../../components/RegisterHeader/RegisterHeader";
// import { Globals } from '../../global/Globals';
import RegisterFooter from "../../components/RegisterFooter/RegisterFooter";
import PopUp from "../../components/PopUp/PopUp";
import Toast from "../../components/Toast/Toast";
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getProducerByProducerID, approveRejectRegistration } from '../../services/SystemAdminAPI';
import { downloadFile } from '../../services/GenericAPI';
import Loader from '../../components/Loader/Loader';
import CryptoUtils from '../../util/cryptoUtils';
import { useLanguage } from '../../context/Languagecontext';

const CompanyRegApprovalRejectionScreen = () => {
    const { Globals ,languages, setLanguages } = useLanguage();
    const navigate = useNavigate();
    const location=useLocation();
    const [isDownloading, setIsDownloading]=useState(false);
    const [actionStatus, setActionStatus] = useState({ isApproved: false, isRejected: false });
    const [toast, setToast] = useState({ open: false, status: '', title: "" });
    const [isData, setIsData] = useState(false);
    const [logoDetails, setLogoDetails] = useState({ name: '', type: 'image/*', downloadPath: '' });
    const [bbbeeeDetails, setBBBEEDetails] = useState({ name: '', type: 'image/*', downloadPath: '' });
    const [taxDetails, setTaxDetails] = useState({ name: '', type: 'image/*', downloadPath: '' });
    const [vat103, setVat103Details] = useState({ name: '', type: 'image/*', downloadPath: '' });
    const [taxInvoice, setTaxInvoiceDetails] = useState({ name: '', type: 'image/*', downloadPath: '' });
    const [regDocs, setRegDocsDetails] = useState({ name: '', type: 'image/*', downloadPath: '' });
    const [bankStamped, setBankStampedDetails] = useState({ name: '', type: 'image/*', downloadPath: '' });
    const producerDetails = useSelector(state => state.ProducerApprovalRejection.producerDetails)
    const [isLoading, setLoading] = useState(false);
    const [logoSource, setLogoSource] = useState('');
    const [isBBBEEDownloading, setIsBBBEEDownloading]=useState(false);
    const [companyData, setCompanyData] = useState({
        companyName: '',
        companyRegNo: '',
        logofile: '',
        title: '',
        name: '',
        email: '',
        website: '',
        socialMediaLinks: '',
        genre: '',
        language: '',
        formats: '',
        productionTypes: '',
        channels: '',
        vatRegistrationNumber: '',
        isVendorRegistered: '',
        vendorRegistrationNumber: '',
        isTaxClearanceCertificate: '',
        taxClearCert: '',
        isBBBEE: '',
        bbbeeeCert: '',
        companyContactNumber: '',
        businessAddress: '',
        companyEmail: '',
        country: '',
        provience: '',
    });
     const [isDocDownloading, setIsDocDownloading] = useState({
        taxFile: false,
        bbbeeFile: false,
        vat103: false,
        taxInvoice: false,
        regDocs: false,
        bankStamped: false
      })

    useEffect(() => {
        const producerID = CryptoUtils.getFromLocalStorage('pKey');
        setLoading(true);
        getProducerByProducerID(producerID).then((response) => {
            setLoading(false);
            if (response?.data?.content) {
                const respData = response?.data?.content;
                const documents = respData?.documents;
                //BBBEE file
                const bbbeeFileName = documents?.find(file => file?.documentFor === 'PBBBEE')?.documentName.trim();
                const bbbeeFileDPath = documents?.find(file => file?.documentFor === 'PBBBEE')?.documentPath.trim();
                setBBBEEDetails({ name: bbbeeFileName, downloadPath: bbbeeFileDPath });
                //Tax Receipt
                const taxReceiptFileName = documents?.find(file => file?.documentFor === 'PTAXCLR')?.documentName;
                const taxReceiptFileDPath = documents?.find(file => file?.documentFor === 'PTAXCLR')?.documentPath;
                setTaxDetails({ name: taxReceiptFileName, downloadPath: taxReceiptFileDPath });
                //Logo
                const logoFileName = documents?.find(file => file?.documentFor === 'PLOGO')?.documentName;
                const logoFileDPath = documents?.find(file => file?.documentFor === 'PLOGO')?.documentPath;
                setLogoDetails({ name: logoFileName, downloadPath: logoFileDPath });
                //VAT103
                const vat130FileName = documents?.find(file => file?.documentFor === 'CVatDoc')?.documentName;
                const vat130FileDPath = documents?.find(file => file?.documentFor === 'CVatDoc')?.documentPath;
                setVat103Details({ name: vat130FileName, downloadPath: vat130FileDPath });
                //Tax Invoice
                const taxInvoiceFileName = documents?.find(file => file?.documentFor === 'CTaxInv')?.documentName;
                const taxInvoiceFileDPath = documents?.find(file => file?.documentFor === 'CTaxInv')?.documentPath;
                setTaxInvoiceDetails({ name: taxInvoiceFileName, downloadPath: taxInvoiceFileDPath });
                //Reg Docs
                const regDocsFileName = documents?.find(file => file?.documentFor === 'CBankDoc')?.documentName;
                const regDocsFileDPath = documents?.find(file => file?.documentFor === 'CBankDoc')?.documentPath;
                setRegDocsDetails({ name: regDocsFileName, downloadPath: regDocsFileDPath });
                //Bank Stamped
                const bankStampedFileName = documents?.find(file => file?.documentFor === 'CBankDoc')?.documentName;
                const bankStampedFileDPath = documents?.find(file => file?.documentFor === 'CBankDoc')?.documentPath;
                setBankStampedDetails({ name: bankStampedFileName, downloadPath: bankStampedFileDPath });

                const languagesList = respData?.languages.map(language => language.languageName);
                const channelsList = respData?.channels.map(channel => channel.channelName);
                const formatsList = respData?.formats.map(_formats => _formats.formatName);
                const genresList = respData?.genres.map(genre => genre.genreName);
                const productioTypesList = respData?.productionTypes?.map(prodType => prodType.productionTypeName);
                const producerRecord = {
                    companyName: respData?.producer?.companyName ? respData?.producer?.companyName : Globals.HALFSCREEN.NA,
                    companyRegNo: respData?.producer?.companyRegNo ? respData?.producer?.companyRegNo : Globals.HALFSCREEN.NA,
                    title: respData?.producer?.title ? respData?.producer?.title : Globals.HALFSCREEN.NA,
                    vatRegistrationNumber: respData?.producer?.vatRegistrationNumber ? respData?.producer?.vatRegistrationNumber : Globals.HALFSCREEN.NA,
                    vendorRegistrationNumber: respData?.producer?.vendorRegistrationNumber ? respData?.producer?.vendorRegistrationNumber : Globals.HALFSCREEN.NA,
                    isTaxClearanceCertificate: respData?.producer?.isTaxClearanceCertificate === true ? Globals.YES : Globals.NO,
                    isBBBEE: respData?.producer?.isBBBEE === true ? Globals.YES : Globals.NO,
                    companyContactNumber: respData?.producer?.companyContactNumber ? respData?.producer?.companyContactNumber : Globals.HALFSCREEN.NA,
                    businessAddress: respData?.producer?.businessAddress ? respData?.producer?.businessAddress : Globals.HALFSCREEN.NA,
                    companyEmail: respData?.producer?.companyEmail ? respData?.producer?.companyEmail : Globals.HALFSCREEN.NA,
                    language: languagesList?.length > 0 ? languagesList.join(', ') : Globals.HALFSCREEN.NA,
                    genre: genresList?.length > 0 ? genresList?.join(', ') : Globals.HALFSCREEN.NA,
                    channels: channelsList?.length > 0 ? channelsList?.join(', ') : Globals.HALFSCREEN.NA,
                    formats: formatsList?.length > 0 ? formatsList?.join(', ') : Globals.HALFSCREEN.NA,
                    productionTypes: productioTypesList.length > 0 ? productioTypesList?.join(', ') : Globals.HALFSCREEN.NA,
                    website: respData?.producer?.website ? respData?.producer?.website : Globals.HALFSCREEN.NA,
                    socialMediaLinks: respData?.producer?.socialMediaLinks ? respData?.producer?.socialMediaLinks.split(','):[],
                    country: respData?.producer?.countryName ? respData?.producer?.countryName : Globals.HALFSCREEN.NA,
                    provience: respData?.producer?.provinceName ? respData?.producer?.provinceName : Globals.HALFSCREEN.NA,
                    email: respData?.producer?.email ? respData?.producer?.email : Globals.HALFSCREEN.NA,
                    name: respData?.producer?.name ? respData?.producer?.name : Globals.HALFSCREEN.NA,
                    isVendorRegistered: respData?.producer?.isVendorRegistered === true ? Globals.YES : Globals.NO,
                    logofile: respData?.producer?.logofile
                };
                setCompanyData(producerRecord);
            }
            else {
                console.error("No producer records found");
                return null;
            }
        }).catch((error) => {
            setLoading(false);
            console.error("Error in getting producer details : ", error);
        })
    }, []);
    const approveProposal = () => {
        setActionStatus({ isApproved: true, isRejected: false });
    }

    const rejectProposal = () => {
        setActionStatus({ isApproved: false, isRejected: true });
    }

    const closePopup = () => {
        setActionStatus({ isApproved: false, isRejected: false });
    }

    const approvalAction = () => {
        approveRejectRegistration(CryptoUtils.getFromLocalStorage('pKey'), true, 'approved').then((response) => {
            if (response?.data?.content?.isSuccess) {
                closePopup();
                goToHomeScreen({ open: true, status: 'success', title:Globals.SYS_ADMIN.TOAST_MESSAGE.APPROVE_COMP});
            }
            else {
               goToHomeScreen({ open: true, status: 'error', title:Globals.SYS_ADMIN.TOAST_MESSAGE.ERROR});
            }
        }).catch((error) => {
            console.error("Error in approving the proposal : ", error);
            goToHomeScreen({ open: true, status: 'error', title:Globals.SYS_ADMIN.TOAST_MESSAGE.ERROR});
        })
    }

    const rejectAction = (emailContentText) => {
        approveRejectRegistration(CryptoUtils.getFromLocalStorage('pKey'), false, emailContentText).then((response) => {
            if (response?.data?.content?.isSuccess) {
                goToHomeScreen({ open: true, status: 'success', title:Globals.SYS_ADMIN.TOAST_MESSAGE.REJECT_COMP});
            }
            else {
                goToHomeScreen({ open: true, status: 'error', title:Globals.SYS_ADMIN.TOAST_MESSAGE.ERROR});
            }
        }).catch((error) => {
            console.error("Error in rejecting the proposal : ", error);
            goToHomeScreen({ open: true, status: 'error', title:Globals.SYS_ADMIN.TOAST_MESSAGE.ERROR});
        })
    }

    const renderToast = (status, title) => {
        setToast({ open: true, status: status, title: title });
        setTimeout(() => {
            setToast({ open: false, status: '', title: '' });
        }, 4000);
    }

    const goToHomeScreen = (toastValue) => {
        //this is to exe the block only if the control is from Haf screen
        if (location?.state?.producerNavProps?.isFromHalfscreen === true) {
            localStorage.setItem('isFromProducerPage', true);
            localStorage.setItem('proposalType', location.state.producerNavProps.selectedTab);
            navigate(Globals.NAVPATH.HOME, { state: { activeHeader: location.state.producerNavProps.activeHeader, selectedTab: location.state.producerNavProps.selectedTab } })
        }
        else {
            navigate(Globals.NAVPATH.HOME, { state: { activeHeader: location.state.activeHeader, toastValue: toastValue } });
        }
        localStorage.removeItem('pKey');
    }

    //This finction is to show the downloading status of the files
    const showDownloadingStatus = (fieldName, statusName) => {
        if (fieldName === 'taxFile' && statusName === 'start') {
            setIsDownloading(true);
        }
        else if (fieldName === 'bbbeeFile' && statusName === 'start') {
            setIsBBBEEDownloading(true);
        }
        else if (fieldName === 'vat103' && statusName === 'start') {
            setIsDocDownloading(prevState => ({ ...prevState, vat103: true }));
        }
        else if (fieldName === 'taxInvoice' && statusName === 'start') {
            setIsDocDownloading(prevState => ({ ...prevState, taxInvoice: true }));
        }
        else if (fieldName === 'regDocs' && statusName === 'start') {
            setIsDocDownloading(prevState => ({ ...prevState, regDocs: true }));
        }
        else if (fieldName === 'bankStamped' && statusName === 'start') {
            setIsDocDownloading(prevState => ({ ...prevState, bankStamped: true }));
        }
        else if (fieldName === 'taxFile' && statusName === 'end') {
            setIsDownloading(false);
        }
        else if (fieldName === 'bbbeeFile' && statusName === 'end') {
            setIsBBBEEDownloading(false);
        }
        else if (fieldName === 'vat103' && statusName === 'end') {
            setIsDocDownloading(prevState => ({ ...prevState, vat103: false }));
        }
        else if (fieldName === 'taxInvoice' && statusName === 'end') {
            setIsDocDownloading(prevState => ({ ...prevState, taxInvoice: false }));
        }
        else if (fieldName === 'regDocs' && statusName === 'end') {
            setIsDocDownloading(prevState => ({ ...prevState, regDocs: false }));
        }
        else if (fieldName === 'bankStamped' && statusName === 'end') {
            setIsDocDownloading(prevState => ({ ...prevState, bankStamped: false }));
        }
    }

    const downloadSelectedFile = (filePath, fileName, fieldName) => {
        const isForProducer = true;
        showDownloadingStatus(fieldName, 'start');
        downloadFile(filePath, isForProducer)
            .then((response) => {
                showDownloadingStatus(fieldName, 'end');
                if (response?.data) {
                    const blob = new Blob([response.data]);
                    const fileUrl = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");

                    link.href = fileUrl;
                    link.setAttribute("download", fileName);
                    document.body.appendChild(link);
                    link.click();
                    // Cleanup
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(fileUrl);
                } else {
                    showDownloadingStatus(fieldName, 'end');
                    console.error("Error: No file data available for download.");
                }
            })
            .catch((error) => {
                //setIsDownloading(false);
                showDownloadingStatus(fieldName, 'end');
                console.error("Error in downloading the file:", error);
            });
    }

    const getLogoSource = async () => {
        try {
            const isForProducer = true;
            const response = await downloadFile(logoDetails.downloadPath, isForProducer);

            if (response?.data) {
                const blob = new Blob([response.data], { type: response.headers['Content-Type'] }); // Ensure correct MIME type
                const fileUrl = URL.createObjectURL(blob);
                // Set image source directly
                setLogoSource(fileUrl);
                setTimeout(() => URL.revokeObjectURL(fileUrl), 5000);
            } else {
                console.error("Error: No file data available for download.");
            }
        } catch (error) {
            console.error("Error in downloading the file:", error);
        }
    };

    useEffect(() => {
        if (logoDetails.downloadPath) {
            getLogoSource();
        }
    }, [logoDetails.downloadPath])

    const getValidURL = (url) => {
        try {
            return new URL(url).href;
        } catch {
            return `https://${url}`;
        }
    };

    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
          document.body.style.overflow = "auto";
        };
      }, []);

    return (
        <div className='company-wrap'>
            <div id="comp-approval-rejection-container" className="comp-approval-rejection-container">
                <RegisterHeader title={Globals.SYS_ADMIN.APPROVE_REJECT_UI.TITLE} isBackNotRequired={true} onCancelRegister={goToHomeScreen} />
            </div>
            <div className='company-body-wrap'>
                <div className='company-infos-wrap'>
                    <div className='company-infos-inner-wrap'>
                        <div className='company-infos'>{Globals.SIGNUP.COMPANY_INFO}</div>
                        <div className='company-infos-details1 company-infos-wrap'>
                            <div className='company-details-wrap1'>
                                <div className='reg-apprval-profile-details'>
                                    <div className='company-details-body reg-approval-profile-pic-container'>
                                        <img src={logoSource || Globals.IMG.PROFILE_BIG} alt="Profile" className="reg-approval-profile-photo" />
                                    </div>
                                    <div className="reg-approval-profile-page-details">
                                        <span className="reg-approval-profile-page-company">{companyData.companyName}</span>
                                        <span className="reg-approval-profile-page-name">{companyData.title && companyData.title.trim() !== "" ? companyData.title.trim().replace(/([^.])$/, '$1.') + " " + companyData.name : companyData.name}</span>
                                        <span className="reg-approval-profile-page-email">{companyData.email}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='company-infos-details1'>
                            <div className='company-details-wrap'>
                                <div className='company-details-head'>{Globals.SIGNUP.COMPANY_REG_NUMBER_LABEL}</div>
                                <div className='company-details-body'>{companyData.companyRegNo}</div>
                            </div>
                            <div className='company-details-wrap'>
                                <div className='company-details-head'>{Globals.SIGNUP.GENRE}</div>
                                <div className='company-details-body user-data-list'>{companyData.genre}</div>
                            </div>
                            <div className='company-details-wrap'>
                                <div className='company-details-head'>{Globals.SIGNUP.LANGUAGE}</div>
                                <div className='company-details-body user-data-list'>{companyData.language}</div>
                            </div>
                            <div className='company-details-wrap'>
                                <div className='company-details-head'>{Globals.SIGNUP.FORMAT_LABEL}</div>
                                <div className='company-details-body user-data-list'>{companyData.formats}</div>
                            </div>
                        </div>
                        <div className='company-infos-details1'>
                            <div className='company-details-wrap'>
                                <div className='company-details-head'>{Globals.SIGNUP.PRODUCTION_TYPE_LABEL}</div>
                                <div className='company-details-body user-data-list'>{companyData.productionTypes}</div>
                            </div>
                            <div className='company-details-wrap'>
                                <div className='company-details-head'>{Globals.SIGNUP.CHANNELS}</div>
                                <div className='company-details-body user-data-list'>{companyData.channels}</div>
                            </div>
                            <div className='company-details-wrap'>
                                <div className='company-details-head'>{Globals.SIGNUP.WEBSITE}</div>
                                <div className='company-details-body'>{companyData.website.toLocaleUpperCase() !== Globals.HALFSCREEN.NA?<a href={getValidURL(companyData.website)} className={companyData.website !== Globals.HALFSCREEN.NA ? "user-website-url2" : ""} target='_blank'>{Globals.WEBSITE_LINK}</a>:Globals.HALFSCREEN.NA}</div>
                            </div>
                            <div className='company-details-wrap'>
                                <div className='company-details-head'>{Globals.SIGNUP.SOCIAL_MEDIA}</div>
                                <div className='company-details-body'>{companyData.socialMediaLinks.length>0?
                                    <>
                                        {companyData?.socialMediaLinks?.[0] && <><a href={getValidURL(companyData.socialMediaLinks[0])} target='_blank'>{Globals.SOCIAL_MEDIA_1}</a><br/></>}
                                        {companyData?.socialMediaLinks?.[1] && <><a href={getValidURL(companyData.socialMediaLinks[1])} target='_blank'>{Globals.SOCIAL_MEDIA_2}</a><br/></>}
                                        {companyData?.socialMediaLinks?.[2] && <><a href={getValidURL(companyData.socialMediaLinks[2])} target='_blank'>{Globals.SOCIAL_MEDIA_3}</a><br/></>}
                                    </>:Globals.HALFSCREEN.NA
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='statutory-infos-wrap'>
                    <div className='statutory-infos-inner-wrap'>
                        <div className='statutory-infos'>{Globals.SIGNUP.SATUTORY_INFO_LABEL}</div>
                        <div className='statutory-infos-details1'>
                            {/* <div className='company-details-wrap'>
                                <div className='statutory-details-head'>{Globals.SIGNUP.VAT_REG_NUM_LABEL}</div>
                                <div className='statutory-details-body'>{companyData.vatRegistrationNumber}</div>
                            </div> */}
                            <div className='company-details-wrap'>
                                <div className='statutory-details-head'>{Globals.SIGNUP.VENDOR_REQUIRED}</div>
                                <div className='statutory-details-body'>{companyData.isVendorRegistered}</div>
                            </div>
                            {companyData.isVendorRegistered === Globals.YES && <div className='company-details-wrap'>
                                <div className='statutory-details-head'>{Globals.SIGNUP.VEN_REG_NUM_LABEL}</div>
                                <div className='statutory-details-body'>{companyData.vendorRegistrationNumber}</div>
                            </div>}
                        </div>
                        <div className='statutory-infos-details1'>
                            {companyData.isVendorRegistered===Globals.NO &&<>
                            <div className='company-details-wrap'>
                                <div className='statutory-details-head'>{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.VAT_CLEARANCE_CERTIFICATE}</div>
                                <div className='statutory-details-body user-file'>{taxDetails.name ? <>{isDownloading? <img width={16} height={16} src={Globals.LOADERS.SPINNING_LOADER} style={{ marginRight: "5px", verticalAlign: "middle" }}/>:<img src={Globals.IMG.FILE_ICON} />}<span className="uploaded-file-name user-reg-approval-download-btn user-uploaded-file-name" id="uploaded-file-name" onClick={() => (!isDownloading ?downloadSelectedFile(taxDetails.downloadPath, taxDetails.name,'taxFile'):null)}>{taxDetails.name}</span><img className="user-reg-approval-download-btn" src={Globals.IMG.DOWNLOAD_FILE} onClick={() => (!isDownloading ?downloadSelectedFile(taxDetails.downloadPath, taxDetails.name, 'taxFile'):null)} /></> : Globals.HALFSCREEN.NA}</div>
                            </div>
                            <div className='company-details-wrap'>
                                <div className='statutory-details-head'>{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.VAT_103}</div>
                                <div className='statutory-details-body user-file'>{vat103.name ? <>{isDocDownloading.vat103? <img width={16} height={16} src={Globals.LOADERS.SPINNING_LOADER} style={{ marginRight: "5px", verticalAlign: "middle" }}/>:<img src={Globals.IMG.FILE_ICON} />}<span className="uploaded-file-name user-reg-approval-download-btn user-uploaded-file-name" id="uploaded-file-name" onClick={() => (!isDocDownloading.vat103 ?downloadSelectedFile(vat103.downloadPath, vat103.name,'vat103'):null)}>{vat103.name}</span><img className="user-reg-approval-download-btn" src={Globals.IMG.DOWNLOAD_FILE} onClick={() => (!isDocDownloading.vat103 ?downloadSelectedFile(vat103.downloadPath, vat103.name, 'vat103'):null)} /></> : Globals.HALFSCREEN.NA}</div>
                            </div>
                            <div className='company-details-wrap'>
                                <div className='statutory-details-head'>{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.TAX_INVOICE}</div>
                                <div className='statutory-details-body user-file'>{taxInvoice.name ? <>{isDocDownloading.taxInvoice? <img width={16} height={16} src={Globals.LOADERS.SPINNING_LOADER} style={{ marginRight: "5px", verticalAlign: "middle" }}/>:<img src={Globals.IMG.FILE_ICON} />}<span className="uploaded-file-name user-reg-approval-download-btn user-uploaded-file-name" id="uploaded-file-name" onClick={() => (!isDocDownloading.taxInvoice ?downloadSelectedFile(taxInvoice.downloadPath, taxInvoice.name,'taxInvoice'):null)}>{taxInvoice.name}</span><img className="user-reg-approval-download-btn" src={Globals.IMG.DOWNLOAD_FILE} onClick={() => (!isDocDownloading.taxInvoice ?downloadSelectedFile(taxInvoice.downloadPath, taxInvoice.name, 'taxInvoice'):null)} /></> : Globals.HALFSCREEN.NA}</div>
                            </div>
                            </>}
                        </div>
                        <div className='statutory-infos-details1'>
                            {companyData.isVendorRegistered===Globals.NO&&<>
                            <div className='company-details-wrap'>
                                <div className='statutory-details-head'>{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.REG_DOCS}</div>
                                <div className='statutory-details-body user-file'>{regDocs.name ? <>{isDocDownloading.regDocs? <img width={16} height={16} src={Globals.LOADERS.SPINNING_LOADER} style={{ marginRight: "5px", verticalAlign: "middle" }}/>:<img src={Globals.IMG.FILE_ICON} />}<span className="uploaded-file-name user-reg-approval-download-btn user-uploaded-file-name" id="uploaded-file-name" onClick={() => (!isDocDownloading.regDocs ?downloadSelectedFile(regDocs.downloadPath, regDocs.name,'regDocs'):null)}>{regDocs.name}</span><img className="user-reg-approval-download-btn" src={Globals.IMG.DOWNLOAD_FILE} onClick={() => (!isDocDownloading.regDocs ?downloadSelectedFile(regDocs.downloadPath, regDocs.name, 'regDocs'):null)} /></> : Globals.HALFSCREEN.NA}</div>
                            </div>
                            <div className='company-details-wrap'>
                                <div className='statutory-details-head'>{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.VALID_BBEEE_CERTIFICATE}</div>
                                <div className='statutory-details-body user-file user-file-holder'>{bbbeeeDetails.name ? <>{isBBBEEDownloading? <img width={16} height={16} src={Globals.LOADERS.SPINNING_LOADER} style={{ marginRight: "5px", verticalAlign: "middle" }}/>:<img src={Globals.IMG.FILE_ICON} />}<span className="uploaded-file-name user-reg-approval-download-btn user-uploaded-file-name" id="uploaded-file-name" onClick={() => (!isBBBEEDownloading?downloadSelectedFile(bbbeeeDetails.downloadPath, bbbeeeDetails.name,'bbbeeFile'):null)}>{bbbeeeDetails.name}</span><img id="donwload-btn" className="download-btn user-reg-approval-download-btn" src={Globals.IMG.DOWNLOAD_FILE} onClick={() => (!isBBBEEDownloading?downloadSelectedFile(bbbeeeDetails.downloadPath, bbbeeeDetails.name,'bbbeeFile'):null)} /></> : Globals.HALFSCREEN.NA}</div>
                            </div>
                            <div className='company-details-wrap'>
                                <div className='statutory-details-head'>{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.BANK_STAMPED}</div>
                                <div className='statutory-details-body user-file'>{bankStamped.name ? <>{isDocDownloading.bankStamped? <img width={16} height={16} src={Globals.LOADERS.SPINNING_LOADER} style={{ marginRight: "5px", verticalAlign: "middle" }}/>:<img src={Globals.IMG.FILE_ICON} />}<span className="uploaded-file-name user-reg-approval-download-btn user-uploaded-file-name" id="uploaded-file-name" onClick={() => (!isDocDownloading.bankStamped ?downloadSelectedFile(bankStamped.downloadPath, bankStamped.name,'bankStamped'):null)}>{bankStamped.name}</span><img className="user-reg-approval-download-btn" src={Globals.IMG.DOWNLOAD_FILE} onClick={() => (!isDocDownloading.bankStamped ?downloadSelectedFile(bankStamped.downloadPath, bankStamped.name, 'bankStamped'):null)} /></> : Globals.HALFSCREEN.NA}</div>
                            </div>
                            </>}
                        </div>
                        {/* <div className='statutory-infos-details2'>
                            <div className='company-details-wrap'>
                                <div className='statutory-details-head'>{Globals.SIGNUP.TAX_CERTIFICATE_QUESTION_LABEL}</div>
                                <div className='statutory-details-body'>{companyData.isTaxClearanceCertificate}</div>
                            </div>
                            <div className='company-details-wrap'>
                                <div className='statutory-details-head'>Tax Clearance certificate/Pin</div>
                                <div className='statutory-details-body user-file'>{taxDetails.name ? <>{isDownloading? <img width={16} height={16} src={Globals.LOADERS.SPINNING_LOADER} style={{ marginRight: "5px", verticalAlign: "middle" }}/>:<img src={Globals.IMG.FILE_ICON} />}<span className="uploaded-file-name user-reg-approval-download-btn user-uploaded-file-name" id="uploaded-file-name" onClick={() => (!isDownloading ?downloadSelectedFile(taxDetails.downloadPath, taxDetails.name,'taxFile'):null)}>{taxDetails.name}</span><img className="user-reg-approval-download-btn" src={Globals.IMG.DOWNLOAD_FILE} onClick={() => (!isDownloading ?downloadSelectedFile(taxDetails.downloadPath, taxDetails.name, 'taxFile'):null)} /></> : Globals.HALFSCREEN.NA}</div>
                            </div>
                        </div>
                        <div className='statutory-infos-details3'>
                            <div className='company-details-wrap'>
                                <div className='statutory-details-head'>{Globals.SIGNUP.BBEE_COMPLIANT_LABEL}</div>
                                <div className='statutory-details-body'>{companyData.isBBBEE}</div>
                            </div>
                            <div className='company-details-wrap'>
                                <div className='statutory-details-head'>B-BBEE Certificate</div>
                                <div className='statutory-details-body user-file user-file-holder'>{bbbeeeDetails.name ? <>{isBBBEEDownloading? <img width={16} height={16} src={Globals.LOADERS.SPINNING_LOADER} style={{ marginRight: "5px", verticalAlign: "middle" }}/>:<img src={Globals.IMG.FILE_ICON} />}<span className="uploaded-file-name user-reg-approval-download-btn user-uploaded-file-name" id="uploaded-file-name" onClick={() => (!isBBBEEDownloading?downloadSelectedFile(bbbeeeDetails.downloadPath, bbbeeeDetails.name,'bbbeeFile'):null)}>{bbbeeeDetails.name}</span><img id="donwload-btn" className="download-btn user-reg-approval-download-btn" src={Globals.IMG.DOWNLOAD_FILE} onClick={() => (!isBBBEEDownloading?downloadSelectedFile(bbbeeeDetails.downloadPath, bbbeeeDetails.name,'bbbeeFile'):null)} /></> : Globals.HALFSCREEN.NA}</div>
                            </div>
                        </div> */}
                        <div className='statutory-infos-details4'>

                        </div>
                    </div>
                </div>
                <div className='contact-infos-wrap'>
                    <div className='contact-infos'>{Globals.SIGNUP.CONTACT_INFO_LABEL}</div>
                    <div className='contact-infos-details'>
                        <div className='company-details-wrap'>
                            <div className='contact-details-head'>{Globals.SIGNUP.COMPANY_CONTACT_NUM_LABEL}</div>
                            <div className='contact-details-body'>{companyData.companyContactNumber}</div>
                        </div>
                        <div className='company-details-wrap'>
                            <div className='contact-details-head'>{Globals.SIGNUP.COMPANY_EMAIL_LABEL}</div>
                            <div className='contact-details-body'>{companyData.companyEmail}</div>
                        </div>
                        <div className='company-details-wrap'>
                            <div className='contact-details-head'>{Globals.SIGNUP.COMPANY_ADDRESS}</div>
                            <div className='contact-details-body'>{companyData.businessAddress}</div>
                        </div>
                        <div className='contact-details-wrap'>
                            <div className='contact-details-head'>{Globals.SIGNUP.COUNTRY}</div>
                            <div className='contact-details-body'>{companyData.country}</div>
                        </div>
                    </div>
                    <div className='contact-infos-details'>
                        <div className='contact-details-wrap element-section2'>
                            <div className='contact-details-head'>{Globals.SIGNUP.PROVIENCE}</div>
                            <div className='contact-details-body'>{companyData.provience}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="reg-approval-footer">
                <span><RegisterFooter tabIndex1={14} tabIndex2={15} isSysAdmin={true} approveProposal={approveProposal} rejectProposal={rejectProposal} onCancelRegister={goToHomeScreen} /></span>
            </div>
            {actionStatus.isApproved && <PopUp
                title={Globals.SYS_ADMIN.POPUP.APPROVE_POPUP_TITLE}
                popupType="approveProposal"
                email={false}
                limit="1024"
                customClassName="email-popup-content"
                onClose={closePopup}
                normalAction={approvalAction}
                normalActionText={Globals.SYS_ADMIN.CTA.APPROVE}
                textAreaStyle="popup-email-text"
                textAreaTitle={Globals.SYS_ADMIN.POPUP.EMAIL_CONTENT}
                proposalBodyVal={"Body"}
            />}
            {actionStatus.isRejected && <PopUp
                title={Globals.SYS_ADMIN.POPUP.REJECT_POPUP_TITLE}
                popupType="rejectProposal"
                email={true}
                limit="1024"
                customClassName="email-popup-content"
                onClose={closePopup}
                negativeAction={(value) => rejectAction(value)}
                negativeActionText={Globals.SYS_ADMIN.CTA.REJECT}
                textAreaStyle="popup-email-text"
                textAreaTitle={Globals.SYS_ADMIN.POPUP.EMAIL_CONTENT}
                proposalBodyVal={"Body"}
                isEmailContentRequired={true}
                emailContent={Globals.SYS_ADMIN.POPUP.REJECT_EMAIL_TEMPLATE}
            />}
            {toast.open && <Toast status={toast.status} title={toast.title} />}
            {isLoading && <Loader width={'50'} height={'50'} component={'approve-reject'} />}
        </div>
    )
}

export default CompanyRegApprovalRejectionScreen;